/**
 * Converts `Action` objects to `ActionMenuItem` objects. Used to implement responsive layouts where action buttons
 * do not fit and must collapse into a drop-down button.
 *
 * @param actions - action to convert to menu items
 */
export function convertActionsToMenuItems(actions) {
    var _a;
    const menuItems = [];
    for (const action of actions) {
        if (action.onClick || !action.menuItems) {
            menuItems.push({
                label: action.label,
                disabled: action.disabled,
                onClick: (_a = action.onClick) !== null && _a !== void 0 ? _a : noop,
                'data-test': action['data-test'],
            });
        }
        else if (action.menuItems) {
            menuItems.push(...action.menuItems);
        }
    }
    return menuItems;
}
function noop() {
    // do nothing
}
